import * as amplitude from "@amplitude/analytics-browser";
import { useAskRedoSlidePanel } from "@redotech/redo-merchant-app-common/ask-redo/ask-redo-slide-panel-context";
import { useAskRedoEnabled } from "@redotech/redo-merchant-app-common/ask-redo/use-ask-redo-enabled";
import { TeamContext } from "@redotech/redo-merchant-app-common/team";
import { checkTeamForAICompliance } from "@redotech/redo-model/agents/util/compliance-util";
import { useAiSlidePanel } from "@redotech/redo-web/ai/chat/contexts/ai-slide-panel-context";
import { Flex } from "@redotech/redo-web/flex";
import { memo, useContext } from "react";
import { PlatformEvents } from "../../../platform-events";
import { SetupGuideNavButton } from "../../../setup-guide/setup-guide-nav-button";
import { AskRedoButton } from "./ask-redo-button";
import * as css from "./merchant-top-navigation.module.css";
import { NotificationsButton } from "./notifications-button";
import { SearchButton } from "./search-button";
import { TeamSwitcher } from "./team-switcher";

export const MerchantAppTopNav = memo(function MerchantAppTopNav() {
  const { toggle: toggleLegacy } = useAiSlidePanel();
  const { toggle: toggleAskRedo } = useAskRedoSlidePanel();
  const { enabled: askRedoEnabled } = useAskRedoEnabled();
  const team = useContext(TeamContext);

  const isAiBlacklisted =
    team && !checkTeamForAICompliance(team._id.toString());

  return (
    <Flex
      align="center"
      className={css.topNav}
      justify="space-between"
      w="full"
    >
      <Flex
        align="center"
        className={css.section}
        gap="lg"
        justify="flex-start"
      >
        <TeamSwitcher />
      </Flex>

      <Flex align="center" className={css.section} gap="lg" justify="center">
        <SearchButton />
      </Flex>

      <Flex align="center" className={css.section} gap="lg" justify="flex-end">
        <SetupGuideNavButton />
        {!isAiBlacklisted && (
          <AskRedoButton
            onClick={() => {
              amplitude.track(PlatformEvents.NAV_ASK_REDO_CLICKED);
              if (askRedoEnabled) {
                toggleAskRedo();
              } else {
                toggleLegacy();
              }
            }}
          />
        )}
        <NotificationsButton />
      </Flex>
    </Flex>
  );
});
